"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _FroalaEditorView = _interopRequireDefault(require("react-froala-wysiwyg/FroalaEditorView"));

var _typesafeActions = require("typesafe-actions");

var _Util = require("../../../components/util/Util");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _announcements = require("../../../redux/announcements/announcements.types");

require("./announcement.scss");

var _AnnouncementForm = _interopRequireDefault(require("../../../components/announcement/AnnouncementForm"));

var _api = require("../../../redux/api/api.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Column
} = _table.default;
const {
  Search
} = _input.default;

class AnnouncementLandingPage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      currentId: -1,
      viewForm: false,
      searchTerm: ''
    };
    this.statusFilters = [{
      text: 'Past',
      value: 'Past'
    }, {
      text: 'Current',
      value: 'Current'
    }, {
      text: 'Future',
      value: 'Future'
    }];

    this.rowClassName = (record, index) => index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';

    this.sorterAlphabetical = (a, b) => a.title.localeCompare(b.title);

    this.sorterStartDate = (a, b) => (0, _moment.default)(a.effectiveStartDate).unix() - (0, _moment.default)(b.effectiveStartDate).unix();

    this.sorterEndDate = (a, b) => {
      if (!a.effectiveEndDate && !b.effectiveEndDate) {
        return 0;
      }

      if (!a.effectiveEndDate) {
        return -1;
      }

      if (!b.effectiveEndDate) {
        return 1;
      }

      return (0, _moment.default)(a.effectiveEndDate).unix() - (0, _moment.default)(b.effectiveEndDate).unix();
    };

    this.renderStatus = (text, record, index) => {
      const {
        announcements
      } = this.props;

      if ((0, _moment.default)(record === null || record === void 0 ? void 0 : record.effectiveStartDate).isAfter() && (0, _moment.default)(record === null || record === void 0 ? void 0 : record.effectiveEndDate).isAfter()) {
        return 'Future';
      }

      if ((0, _moment.default)(record === null || record === void 0 ? void 0 : record.effectiveStartDate).isSameOrBefore() && (0, _moment.default)(record === null || record === void 0 ? void 0 : record.effectiveEndDate).isSameOrAfter()) {
        return 'Current';
      }

      let isLatest = false;

      if (!(record === null || record === void 0 ? void 0 : record.effectiveEndDate)) {
        isLatest = !(announcements === null || announcements === void 0 ? void 0 : announcements.some(a => (0, _moment.default)(a.effectiveStartDate).isAfter(record === null || record === void 0 ? void 0 : record.effectiveStartDate)));
      }

      return isLatest ? 'Current' : 'Past';
    };

    this.renderActions = value => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "announcement-action-container"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: "Edit",
        className: "announcement-action",
        onClick: e => {
          e.stopPropagation();
          this.openForm(value);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "far fa-edit fa-lg"
      })));
    };

    this.openForm = value => {
      this.setState({
        currentId: value || this.state.currentId,
        viewForm: true
      });
    };

    this.expandedRowRenderer = record => /*#__PURE__*/_react.default.createElement(_FroalaEditorView.default, {
      model: record.body
    });

    this.onFilterStatus = (value, record) => {
      const {
        announcements
      } = this.props;
      let announcementsArray = announcements !== null && announcements !== void 0 ? announcements : [];

      if (record) {
        switch (value) {
          case 'Past':
            return (0, _moment.default)(record.effectiveStartDate).isBefore() && ((0, _moment.default)(record.effectiveEndDate).isBefore() || announcementsArray.some(a => (0, _moment.default)(a.effectiveStartDate).isAfter(record.effectiveStartDate)));

          case 'Current':
            return record.effectiveEndDate ? (0, _moment.default)(record.effectiveStartDate).isSameOrBefore() && (0, _moment.default)(record.effectiveEndDate).isSameOrAfter() : !announcementsArray.some(a => (0, _moment.default)(a.effectiveStartDate).isAfter(record.effectiveStartDate));

          case 'Future':
            return (0, _moment.default)(record.effectiveStartDate).isAfter() && (0, _moment.default)(record.effectiveEndDate).isAfter();

          default:
            return false;
        }
      }

      return false;
    };

    this.onFilterArms = (value, record) => {
      if (record) {
        return `${record.type}-${record.typeId}` === value;
      }

      return false;
    };

    this.closeForm = () => {
      this.setState({
        viewForm: false,
        currentId: -1
      });
    };

    this.capitalize = s => s ? s.split(' ').map(word => word[0].toUpperCase() + word.substring(1)).join(' ') : s;

    this.renderTypeTypeId = (text, record, index) => {
      return /*#__PURE__*/_react.default.createElement("span", null, `${this.capitalize(record.type)} ${record.typeId}`);
    };

    this.search = e => {
      this.setState({
        searchTerm: e.target.value
      });
    };

    this.handleRowClick = record => {
      if (record && record.id) {
        this.setState({
          currentId: record.id,
          viewForm: true
        });
      }
    };
  }

  componentDidMount() {
    const {
      studyId,
      loadAnnouncements
    } = this.props;
    loadAnnouncements(studyId);
  }

  componentDidUpdate() {
    const {
      createAnnouncementStatus,
      updateAnnouncementStatus,
      clearLoadStatus
    } = this.props;

    if (createAnnouncementStatus.isError || updateAnnouncementStatus.isError) {
      _message2.default.error('Announcement conflicts with another existing announcement start and end date.');

      clearLoadStatus((0, _typesafeActions.getType)(_announcements.createAnnouncementAsync.failure));
      clearLoadStatus((0, _typesafeActions.getType)(_announcements.updateAnnouncementAsync.failure));
    }

    if (createAnnouncementStatus.isSuccess || updateAnnouncementStatus.isSuccess) {
      _message2.default.success('Announcement successfully created.');

      clearLoadStatus((0, _typesafeActions.getType)(_announcements.createAnnouncementAsync.success));
      clearLoadStatus((0, _typesafeActions.getType)(_announcements.updateAnnouncementAsync.success));
    }
  }

  render() {
    const {
      announcements,
      arms,
      studyId
    } = this.props;
    const {
      currentId,
      viewForm,
      searchTerm
    } = this.state;
    const currentAnnouncement = announcements === null || announcements === void 0 ? void 0 : announcements.find(a => a.id === currentId);
    const regex = new RegExp(searchTerm, 'i');
    const displayedAnnouncements = searchTerm && searchTerm.length ? _.filter(announcements, a => regex.test(a.title) || regex.test(a.body)) : announcements;
    const armsFilters = arms ? arms.map(arm => {
      return {
        text: `${arm.name}`,
        value: `arm-${arm.id}`
      };
    }) : [];
    armsFilters.push({
      text: `Study ${studyId}`,
      value: `study-${studyId}`
    });
    return /*#__PURE__*/_react.default.createElement(_card.default, {
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "announcement-title"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Announcements"), /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary",
        onClick: e => {
          e.stopPropagation();
          this.openForm();
        }
      }, "+ Add Announcement"))
    }, viewForm && /*#__PURE__*/_react.default.createElement(_AnnouncementForm.default, {
      announcement: currentAnnouncement,
      visible: viewForm,
      closeHandler: this.closeForm
    }), /*#__PURE__*/_react.default.createElement(Search, {
      placeholder: "Search text",
      onChange: this.search,
      style: {
        width: 200,
        marginBottom: '10px'
      }
    }), /*#__PURE__*/_react.default.createElement(_table.default, {
      dataSource: displayedAnnouncements,
      rowKey: "id",
      rowClassName: this.rowClassName,
      expandedRowRender: this.expandedRowRenderer,
      scroll: {
        y: 500
      },
      pagination: false,
      onRow: (record, rowIndex) => {
        return {
          onClick: event => this.handleRowClick(record),
          onDoubleClick: event => {},
          onContextMenu: event => {},
          onMouseEnter: event => {},
          onMouseLeave: event => {}
        };
      }
    }, /*#__PURE__*/_react.default.createElement(Column, {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: this.renderTypeTypeId,
      filters: armsFilters,
      onFilter: this.onFilterArms
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: this.sorterAlphabetical
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Start Date",
      dataIndex: "effectiveStartDate",
      key: "effectiveStartDate",
      render: _Util.renderDateWithTimeTwelveHourPeriod,
      sorter: this.sorterStartDate,
      defaultSortOrder: "descend"
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "End Date",
      dataIndex: "effectiveEndDate",
      key: "effectiveEndDate",
      render: _Util.renderDateWithTimeTwelveHourPeriod,
      sorter: this.sorterEndDate
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Status",
      dataIndex: "typeId",
      key: "typeId",
      render: this.renderStatus,
      filters: this.statusFilters,
      onFilter: this.onFilterStatus
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "",
      dataIndex: "id",
      key: "id",
      render: this.renderActions
    })));
  }

}

const mapStateToProps = state => {
  return {
    studyId: selectors.getRequestedStudyId(state),
    arms: selectors.getRequestedStudyStudyArms(state),
    announcements: selectors.getAnnouncements(state),
    loadAnnouncementsStatus: selectors.loadAnnouncementsStatus(state),
    createAnnouncementStatus: selectors.createAnnouncementStatus(state),
    updateAnnouncementStatus: selectors.updateAnnouncementStatus(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadAnnouncements: studyId => dispatch(_announcements.getAnnouncementsAsync.request(studyId)),
    clearLoadStatus: type => dispatch((0, _api.clearStatus)(type))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AnnouncementLandingPage);

exports.default = _default;